import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'cnx_refund_options';
export const route = 'cnx_refund_options/[[...token]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "cnx_refund_options" */
/* webpackPrefetch: true */
'../components/RefundOptionsPage')));